<template>
    <!--新手指引-->
  <div class="view-guide">
    <div v-if="currentIndex === 1" class="item">
      <img src="/images/signFlow/index.gif"/>
      <img @click="currentIndex = 2" :style="lists[currentIndex-1]" class="click" src="/images/signFlow/click.gif"/>
    </div>
    <div v-else-if="currentIndex === 2" class="item">
      <img src="/images/signFlow/choiceFile.gif"/>
      <img @click="currentIndex = 3" :style="lists[currentIndex-1]" class="click" src="/images/signFlow/click.gif"/>
    </div>
    <div v-else-if="currentIndex === 3" class="item">
      <img src="/images/signFlow/addSigner.gif"/>
      <img @click="currentIndex = 4" :style="lists[currentIndex-1]" class="click" src="/images/signFlow/click.gif"/>
    </div>
    <div v-else-if="currentIndex === 4" class="item">
      <img src="/images/signFlow/setSinger.gif"/>
      <img @click="currentIndex = 5" :style="lists[currentIndex-1]" class="click" src="/images/signFlow/click.gif"/>
    </div>
    <div v-else-if="currentIndex === 5" class="item">
      <img src="/images/signFlow/signList.gif"/>
      <img @click="currentIndex = 6" :style="lists[currentIndex-1]" class="click" src="/images/signFlow/click.gif"/>
    </div>
    <div v-else-if="currentIndex === 6" class="item">
      <img src="/images/signFlow/signature.gif"/>
      <img @click="currentIndex = 7" :style="lists[currentIndex-1]" class="click" src="/images/signFlow/click.gif"/>
    </div>
    <div v-else-if="currentIndex === 7" class="item">
      <img src="/images/signFlow/signFinish.gif"/>
      <img @click="currentIndex = 1" :style="lists[currentIndex-1]" class="click" src="/images/signFlow/click.gif"/>
    </div>
  </div>
</template>

<script>
    export default {
      data () {
        return {
          lists: [
            {top: '20%',right: '25%'},
            {top: '75%', right: '44%'},
            {top: '10%', right: '5%'},
            {top: '92%', right: '49%'},
            {top: '39%', right: '13%'},
            {top: '10%', right: '4%'},
            {top: '57%', right: '48%'}
          ],
          currentIndex: 1
        }
      },
        name: "viewGuide"
    }
</script>

<style lang="less" scoped>
  .view-guide {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 56px;
    margin-bottom: 40px;
    .item {
      width: 100%;
      border: 1px solid #eeeeee;
      position: relative;
      img {
        width: 100%;
      }
      img.click {
        width: 44px;
        height: 44px;
        opacity: .6;
        position: absolute;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// pages/signInfo/viewGuide.vue